import { Link } from "react-router-dom";
import { Headphones, ArrowRight, ChevronRight } from "lucide-react";

export const GenreRow = ({ genres = [] }) => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="genres-section">
    <div className="flex items-center gap-3 mb-6">
      <span className="w-10 h-10 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center"><Headphones className="w-5 h-5" /></span>
      <div>
        <h2 className="font-display text-2xl sm:text-3xl font-black text-slate-900">Discover New Sounds</h2>
        <p className="text-sm text-slate-500">Explore genres from every culture. Click a card to dive deeper.</p>
      </div>
      <Link to="/genres" data-testid="genres-view-all" className="ml-auto text-sm font-bold text-pink-600 hover:text-pink-700 inline-flex items-center gap-1">
        Explore All Genres <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4">
      {genres.map((g) => (
        <Link key={g.slug} to={`/genres/${g.slug}`} data-testid={`genre-card-${g.slug}`} className="card-lift bg-white rounded-2xl border border-slate-100 overflow-hidden group">
          <div className="h-24 overflow-hidden">
            <img src={g.image} alt={g.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          </div>
          <div className="p-3">
            <p className="font-bold text-sm text-slate-900 flex items-center justify-between">
              {g.name} <ChevronRight className="w-3.5 h-3.5 text-slate-300 group-hover:text-pink-500 transition-colors" />
            </p>
            <p className="text-[11px] text-slate-500 mt-0.5 line-clamp-1">{g.tagline}</p>
          </div>
        </Link>
      ))}
    </div>
  </section>
);

export default GenreRow;
